import React, { useState } from "react";
import artistsData from "../Artists/artistsData";

export default function Artists() {
  // Grabs the first 4 artists
  const landingPageArtists = artistsData.slice(0, 4);

  const [hoveredArtworkId, setHoveredArtworkId] = useState(null);

  function handleMouseEnter(id) {
    console.log("Image: " + id);
    setHoveredArtworkId(id);
  }

  function handleMouseLeave() {
    setHoveredArtworkId(null);
  }

  return (
    <>
      {landingPageArtists.map((artist, index) => {
        const { image, name, licence, description, gallery, social } = artist;
        return (
          <>
            <div
              key={index}
              className="artist-column col-lg-3 col-md-6 col-sm-6"
            >
              <div className="card">
                <img className="card-img-top" src={image} alt="Artist" />
                <div className="card-body">
                  <h5 className="card-title">{name}</h5>
                  <p className="card-text">Licence number: {licence}</p>
                  {/* Button trigger modal */}
                  <button
                    type="button"
                    className="btn-artist btn-dark btn-block"
                    data-toggle="modal"
                    data-target={"#" + name}
                  >
                    VIEW ARTIST
                  </button>
                </div>
              </div>
            </div>
            {/* <!-- Vertically centered modal -->
                  <!-- Modal --> */}
            <div
              className="modal fade"
              id={name}
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalCenterTitle"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLongTitle">
                      {name}
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <img
                    // Option 1
                    // className={`card-img-top artist-profile ${
                    //   hoveredArtworkId === 0 ||
                    //   hoveredArtworkId === 1 ||
                    //   hoveredArtworkId === 2 ||
                    //   hoveredArtworkId === 3
                    //     ? "artwork-display-hide"
                    //     : null
                    //   }`}
                    // Option 2 - Cleaner code
                    className={`card-img-top artist-profile ${
                      [0, 1, 2, 3].includes(hoveredArtworkId)
                        ? "artwork-display-hide"
                        : ""
                    }`}
                    src={image}
                    alt="Artist"
                  />
                  {/* <!-- Hidden display --> */}
                  {/* <img
                    className="card-img-top artwork-display"
                    id="artwork1"
                    src={gallery[0]}
                    alt="Artist"
                  />
                  <img
                    className="card-img-top artwork-display"
                    id="artwork2"
                    src={gallery[1]}
                    alt="Artist"
                  />
                  <img
                    className="card-img-top artwork-display"
                    id="artwork3"
                    src={gallery[2]}
                    alt="Artist"
                  />
                  <img
                    className="card-img-top artwork-display"
                    id="artwork4"
                    src={gallery[4]}
                    alt="Artist"
                  /> */}
                  {gallery.map((imageSrc, index) => (
                    <img
                      key={index}
                      src={imageSrc}
                      alt="Artist"
                      className={`card-img-top artwork-display-hide ${
                        hoveredArtworkId === index ? "artwork-display-show" : ""
                      }`}
                    />
                  ))}
                  <div className="modal-body">
                    <p>{description}</p>
                    <div className="artist-artwork">
                      {/* <img
                        src={gallery[0]}
                        alt=""
                        className="artwork-thumbnail"
                        id="1"
                      />
                      <img
                        src={gallery[1]}
                        alt=""
                        className="artwork-thumbnail"
                        id="2"
                      />
                      <img
                        src={gallery[2]}
                        alt=""
                        className="artwork-thumbnail"
                        id="3"
                      />
                      <img
                        src={gallery[3]}
                        alt=""
                        className="artwork-thumbnail"
                        id="4"
                      /> */}
                      {gallery.map((imageSrc, index) => (
                        <img
                          key={index}
                          src={imageSrc}
                          alt=""
                          className="artwork-thumbnail"
                          id={index}
                          onMouseEnter={() => handleMouseEnter(index)}
                          onMouseLeave={handleMouseLeave}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <a
                      href={social}
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <span className="view-profile">VIEW PROFILE</span>
                      <i className="fab fa-instagram artist-social-icon"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      })}
    </>
  );
}
